export default "__VITE_ASSET__XAtuolAf__"